import API from '@/utils/API';
import { IUser } from '@/types/API';

export const fetchUserInfo = () => {
  const query = `query {
        user: getUserInfo {
            PK
            SK
            id
            email
            type
            avatar
            firstName
            lastName
            phoneNumber
            onboarding
            company {
              name
              id
              domain
              logo {
                url
              }
            }
            address {
                address
                officeAddress
                city
                state
                zip
            }
        }
    }`;

  return API.graphql<IUser>('asset', {
    query,
    variables: {}
  });
};
